export default "__VITE_ASSET__mBvdqrgN__"